module.exports = {
  "dof-marquee": {
    "overflow": "hidden"
  },
  "wrap": {
    "overflow": "hidden",
    "position": "relative"
  },
  "marquee1": {
    "position": "absolute",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "marquee2": {
    "position": "absolute",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "text-item": {
    "lines": 1,
    "overflow": "hidden",
    "whiteSpace": "nowrap",
    "textOverflow": "ellipsis"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-04774a7f!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-marquee/index.vue
// module id = 415
// module chunks = 0 1